<template>
  <b-modal
    id="modal-rejection-reason"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <img
      src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
      alt="warning"
      width="90"
      height="100"
      class="mx-auto mt-[16px] mb-[8px]"
    >
    <h4 class="text-black text-center text-[20px] font-semibold mb-[18px]">
      Produk Ditolak
    </h4>
    <p
      v-if="isSuccesfullyRejected"
      class="text-center mb-[18px]"
    >
      Kamu memutuskan untuk tidak menerima produk ini di gudangmu.
    </p>
    <div v-else>
      <p class="text-black text-[14px] mb-[4px]">
        Isi alasan penolakan:
      </p>
      <validation-observer v-slot="{ invalid }">
        <validation-provider
          #default="{ errors }"
          name="Alasan penolakan"
          rules="required|min:10"
        >
          <b-textarea
            v-model="rejectionReason"
            class="min-h-[100px]"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        <div class="flex items-center justify-end gap-[8px] mt-[18px]">
          <b-button
            variant="primary"
            :disabled="invalid || isOnMutateRejection"
            @click="handleReject"
          >
            <b-spinner
              v-if="isOnMutateRejection"
              small
              class="mr-1"
            />
            {{ isOnMutateRejection ? 'Memproses...' : 'Tolak Pengajuan' }}
          </b-button>
        </div>
      </validation-observer>
    </div>
    <b-button
      v-if="isSuccesfullyRejected"
      class="w-full"
      variant="primary"
      @click="hide"
    >
      Selesai
    </b-button>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min } from '@validations'
import { toastError } from '@/libs/toastification'

export default {
  name: 'ModuleRejectionReason',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      rejectionReason: '',
      isOnMutateRejection: false,
      isSuccesfullyRejected: false,
    }
  },
  methods: {
    show() {
      this.rejectionReason = ''
      this.isOnMutateRejection = false
      this.isSuccesfullyRejected = false
      this.$bvModal.show('modal-rejection-reason')
    },
    hide() {
      this.$bvModal.hide('modal-rejection-reason')
    },
    handleReject() {
      if (!this.rejectionReason || this.rejectionReason.trim().length < 10) {
        return
      }

      this.isOnMutateRejection = true

      const rejectPayload = {
        reason: this.rejectionReason,
      }

      this.$http_new.post(`/komship/api/v1/submissions/${this.$route.params.id}/reject`, rejectPayload)
        .then(response => {
          this.$emit('on-success')
          this.isSuccesfullyRejected = true
          // this.$bvModal.hide('modal-rejection-reason')
          this.rejectionReason = ''
        }).catch(() => {
          toastError('Gagal menolak pengajuan, silahkan coba lagi.')
        }).finally(() => {
          this.isOnMutateRejection = false
        })
    },
  },
}
</script>
